"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewDocumentElementWrapper = void 0;
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../../../constants/constants");
const document_1 = require("../../../../../reducers/slices/document/document");
const form_element_1 = require("./form_element");
const react_redux_1 = require("react-redux");
const core_1 = require("@dnd-kit/core");
const scaleFunction_1 = require("../../../../../helpers/scaleFunction");
const responsiveSize_1 = require("../../../../../helpers/responsiveSize");
const react_resizable_1 = require("react-resizable");
require("react-resizable/css/styles.css");
const update_single_element_thunk_1 = require("../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const main_1 = require("../../../../../reducers/slices/main");
const PreviewDocumentElementWrapper = ({ element }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, resizeMode } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    // Get document dimensions (from PDF or defaults)
    // Use selectedDocument as dependency to recalculate when document changes
    const docDimensions = (0, react_1.useMemo)(() => (0, scaleFunction_1.getDocumentDimensions)(selectedDocument), [selectedDocument]);
    const [labelPosition, setLabelPosition] = (0, react_1.useState)("top");
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const wrapperRef = (0, react_1.useRef)(null);
    // Store original (unscaled) dimensions - these are what get saved to database
    const [elementSize, setElementSize] = (0, react_1.useState)({
        width: element.width || (0, responsiveSize_1.getResponsiveSize)(200, "width"),
        height: element.height || (0, responsiveSize_1.getResponsiveSize)(100, "height"),
    });
    // Calculate scaled dimensions for display
    const scaledWidth = (0, scaleFunction_1.scaleFunction)(elementSize.width);
    const scaledHeight = (0, scaleFunction_1.scaleFunction)(elementSize.height);
    const isResizingRef = (0, react_1.useRef)(false); // Track if user is actively resizing
    const Elem = form_element_1.DocumentElements[element.type].documentComponent;
    // Handle click outside to unfocus on mobile
    (0, react_1.useEffect)(() => {
        if (!constants_1.IS_MOBILE || !isFocused)
            return;
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsFocused(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [isFocused]);
    // Sync local elementSize with element prop changes when:
    // 1. Element ID changes (switching to different element)
    // 2. Element dimensions change from external source (e.g., Redux update after save)
    // Skip sync during active resize to prevent jumping
    (0, react_1.useEffect)(() => {
        // Don't sync during active resize - user's drag takes precedence
        if (isResizingRef.current)
            return;
        const newWidth = element.width || (0, responsiveSize_1.getResponsiveSize)(200, "width");
        const newHeight = element.height || (0, responsiveSize_1.getResponsiveSize)(100, "height");
        setElementSize({ width: newWidth, height: newHeight });
    }, [element._id, element.width, element.height]);
    // Position style for fillable elements - use absolute positioning ONLY for:
    // - Fillable field types that need precise positioning (Signature, Initials, TextField, Date, Checkbox, Radio Buttons)
    // - Page backgrounds (PDF page images) - need to fill the entire page
    // Block elements (Text, Paragraph, Spacer, Page Break) should NEVER be absolutely positioned - they flow naturally
    const isSignatureOrInitialsField = element.type === "Signature" || element.type === "Initials";
    const isBlockElement = element.type === "Text" || element.type === "Paragraph" || element.type === "Spacer" || element.type === "Page Break";
    // Check if this is a Text element containing only an image (likely a PDF page background)
    const textContent = ((_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.text) || "";
    const isPageBackground = element.type === "Text" && (textContent.trim().startsWith("<img") ||
        (textContent.trim().startsWith("<p>") && textContent.includes("<img") && !textContent.replace(/<img[^>]*>/g, "").replace(/<\/?p>/g, "").trim()));
    // Only position fillable form fields absolutely - NEVER text content (except page backgrounds)
    const isFillableField = isPageBackground || (!isBlockElement && (element.type === "Signature" ||
        element.type === "Initials" ||
        element.type === "TextField" ||
        element.type === "Date" ||
        element.type === "Checkbox" ||
        element.type === "Radio Buttons"));
    // Get current scale factor for responsive scaling (moved up for use in sizing)
    const scaleFactor = (0, scaleFunction_1.getScaleFactor)();
    // Element dimensions in original document space
    // For page backgrounds (PDF images), use full page dimensions
    // On mobile: make container LARGER so content has room, then scale down visually
    const isMobile = scaleFactor < 0.6;
    // EXCEPTION: Signature/Initials fields use ResizableBox which handles sizing directly,
    // so don't apply the mobile multiplier to them (prevents size jumping between resize/move modes)
    const shouldApplyMobileMultiplier = isMobile && !isSignatureOrInitialsField && !isPageBackground;
    const containerMultiplier = shouldApplyMobileMultiplier ? 2 : 1;
    const originalWidth = isPageBackground ? docDimensions.width : (element.width || 144) * containerMultiplier;
    const originalHeight = isPageBackground ? docDimensions.height : (element.height || 48) * containerMultiplier;
    // CSS transform scale for mobile - scales the entire field visually back down
    // 2x container * 0.5 scale = same visual size as desktop, but with room for content
    // Signature/Initials fields handle their own sizing via ResizableBox
    const fieldTransformScale = shouldApplyMobileMultiplier ? 0.5 : 1;
    // For page backgrounds, always treat as positioned at 0,0 even if x is undefined
    const xPos = isPageBackground ? 0 : (((_b = element.extra_attributes) === null || _b === void 0 ? void 0 : _b.x) || 0);
    const yPos = isPageBackground ? 0 : (((_c = element.extra_attributes) === null || _c === void 0 ? void 0 : _c.y) || 0);
    // Position and size style for fillable elements - use percentage positioning
    // Block elements (Text, Paragraph) flow naturally without absolute positioning
    const style = isFillableField
        ? Object.assign(Object.assign({ position: "absolute", 
            // Page backgrounds at z-index 0, fields at z-index 50 to ensure fields are always on top
            zIndex: isPageBackground ? 0 : 50, left: `${(xPos / docDimensions.width) * 100}%`, top: `${(yPos / docDimensions.height) * 100}%` }, ((isSignatureOrInitialsField || isPageBackground || (element === null || element === void 0 ? void 0 : element.width) !== undefined)
            ? {
                width: `${(originalWidth / docDimensions.width) * 100}%`,
                height: `${(originalHeight / docDimensions.height) * 100}%`,
            }
            : {})), (isPageBackground ? { pointerEvents: "none" } : {})) : {};
    // Get signer information for this field
    const getSignerInfo = () => {
        var _a, _b;
        try {
            const userObj = (_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.user;
            const userId = ((_b = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _b === void 0 ? void 0 : _b.user_id) || (userObj === null || userObj === void 0 ? void 0 : userObj._id);
            const userEmail = userObj === null || userObj === void 0 ? void 0 : userObj.email;
            // Check if field has any user assignment
            const hasUserAssignment = userId || userEmail || userObj;
            if (!hasUserAssignment) {
                return null;
            }
            // Helper to extract name from user object (handles different property names)
            const extractUserName = (user) => {
                if (!user)
                    return "";
                const firstName = user.first_name || user.name || "";
                const lastName = user.last_name || user.surname || "";
                return `${firstName} ${lastName}`.trim();
            };
            // Try to find signer in document signers list first
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) && Array.isArray(selectedDocument.signers)) {
                const signer = selectedDocument.signers.find((s) => (userId && (s.user_id === userId || s._id === userId)) ||
                    (userEmail && s.email === userEmail));
                if (signer) {
                    return {
                        name: `${signer.first_name || ""} ${signer.last_name || ""}`.trim() || signer.email,
                        email: signer.email,
                    };
                }
            }
            // Fallback to user info from element
            if (userObj) {
                const email = userEmail || "unknown";
                const name = extractUserName(userObj);
                return {
                    name: name || email,
                    email: email,
                };
            }
            return null;
        }
        catch (error) {
            console.warn("Error getting signer info:", error);
            return null;
        }
    };
    const signerInfo = getSignerInfo();
    // Generate a unique color for each user based on their email
    const getUserColor = (email) => {
        // Simple hash function to generate consistent color from email
        let hash = 0;
        for (let i = 0; i < email.length; i++) {
            hash = email.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Generate HSL color with good saturation and lightness for readability
        const hue = Math.abs(hash % 360);
        const saturation = 65 + (Math.abs(hash) % 20); // 65-85%
        const lightness = 45 + (Math.abs(hash >> 8) % 15); // 45-60%
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };
    // Dynamic label positioning - position label opposite to cursor location
    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        // Calculate distances to edges to find closest edge (where cursor is)
        const distanceToTop = y;
        const distanceToBottom = rect.height - y;
        const distanceToLeft = x;
        const distanceToRight = rect.width - x;
        // Find the closest edge (where cursor is pointing) and position label on opposite side
        const minDistance = Math.min(distanceToTop, distanceToBottom, distanceToLeft, distanceToRight);
        if (minDistance === distanceToTop) {
            // Cursor near top, position label at bottom
            setLabelPosition("bottom");
        }
        else if (minDistance === distanceToBottom) {
            // Cursor near bottom, position label at top
            setLabelPosition("top");
        }
        else if (minDistance === distanceToLeft) {
            // Cursor near left, position label at right
            setLabelPosition("right");
        }
        else {
            // Cursor near right, position label at left
            setLabelPosition("left");
        }
    };
    // Get label classes based on position
    const getLabelClasses = () => {
        const baseClasses = "absolute text-white px-2 py-1 rounded text-xs shadow-lg z-[1000] pointer-events-none flex items-center gap-1 max-w-[120px] sm:max-w-[200px]";
        switch (labelPosition) {
            case "top":
                return `${baseClasses} -top-8 left-0`;
            case "bottom":
                return `${baseClasses} -bottom-8 left-0`;
            case "left":
                return `${baseClasses} top-0 -left-2 -translate-x-full`;
            case "right":
                return `${baseClasses} top-0 -right-2 translate-x-full`;
            default:
                return `${baseClasses} -top-8 left-0`;
        }
    };
    // Handle resize start - mark as resizing to prevent useEffect sync
    const handleResizeStart = () => {
        isResizingRef.current = true;
    };
    // Handle resize of signature/initials - convert scaled values back to original
    const handleResize = (event, { size }) => {
        // ResizableBox gives us scaled pixel values, convert back to original for storage
        const unscaledWidth = size.width / scaleFactor;
        const unscaledHeight = size.height / scaleFactor;
        setElementSize({
            width: unscaledWidth,
            height: unscaledHeight,
        });
    };
    const handleResizeStop = (event, { size }) => __awaiter(void 0, void 0, void 0, function* () {
        // Convert scaled values back to original for storage
        const unscaledWidth = size.width / scaleFactor;
        const unscaledHeight = size.height / scaleFactor;
        const updatedElement = Object.assign(Object.assign({}, element), { width: unscaledWidth, height: unscaledHeight, extra_attributes: Object.assign({}, element.extra_attributes) });
        dispatch((0, document_1.editSelectedDocumentElements)(updatedElement));
        // Guard: don't attempt save if document ID is missing - show user feedback
        if (!(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id)) {
            dispatch((0, main_1.setMessageModal)({
                title: "Unable to Save Changes",
                messages: [
                    "Your resize could not be saved because the document context was lost.",
                    "Please refresh the page and try again.",
                ],
            }));
            isResizingRef.current = false;
            return;
        }
        // Save to backend and wait for completion
        try {
            yield dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument._id,
                    payload: updatedElement,
                    documentStatus: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status,
                },
            })).unwrap();
        }
        catch (_l) {
            // Error is already handled in the thunk (shows modal to user)
        }
        finally {
            // Clear resizing flag after save completes (success or failure)
            isResizingRef.current = false;
        }
    });
    // Check if element should be resizable based on scaling mode and field state
    // - scaling_mode "custom": Always show resize handles (for unsigned fields in signing view)
    // - scaling_mode "fixed": Never resizable
    // - scaling_mode "auto": Not resizable (auto-scales to content)
    // - For signed fields with resizeMode enabled: Allow resizing regardless of scaling_mode
    const scalingMode = (_d = element.scaling_mode) !== null && _d !== void 0 ? _d : "custom";
    const isSignedField = (element.type === "Signature" || element.type === "Initials") && ((_e = element.extra_attributes) === null || _e === void 0 ? void 0 : _e.value);
    const isSignatureOrInitials = element.type === "Signature" || element.type === "Initials";
    // Check if field belongs to another user (not current user)
    // Check both user email, accessAuth user_id (for mobile/access link), AND user._id (for logged-in users)
    const assignedEmail = (_g = (_f = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _f === void 0 ? void 0 : _f.user) === null || _g === void 0 ? void 0 : _g.email;
    const assignedUserId = ((_h = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _h === void 0 ? void 0 : _h.user_id) || ((_k = (_j = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _j === void 0 ? void 0 : _j.user) === null || _k === void 0 ? void 0 : _k._id);
    // If no user is assigned, it's NOT another user's field
    const hasAssignment = !!(assignedEmail || assignedUserId);
    // Check by email (case-insensitive)
    const isCurrentUserByEmail = !!(assignedEmail && (user === null || user === void 0 ? void 0 : user.email) &&
        assignedEmail.toLowerCase() === user.email.toLowerCase());
    // Check by user_id - check BOTH accessAuth (mobile/link) AND user._id (logged-in user)
    const isCurrentUserById = !!(assignedUserId && (((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.user_id) && String(assignedUserId) === String(accessAuth.user_id)) ||
        ((user === null || user === void 0 ? void 0 : user._id) && String(assignedUserId) === String(user._id))));
    // Only "other user's field" if assigned AND current user doesn't match
    const isOtherUsersField = hasAssignment && !isCurrentUserByEmail && !isCurrentUserById;
    // Document is locked when completed - no more field modifications allowed
    const isDocumentCompleted = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "COMPLETED";
    // Per client request 2026-04-29: Signature and Initials fields cannot be
    // moved or resized once the document leaves DRAFT. The previous behaviour
    // (resize via the "RESIZE: OFF/ON" toggle, drag when toggle was off) is
    // intentionally disabled here rather than removed so a future iteration
    // can revisit signer-side adjustments. The DRAFT editor keeps full move
    // and resize ability via document_element_wrapper.tsx.
    const isResizable = false;
    const isDraggable = false;
    // Reference unused locals so eslint/tsc doesn't flag them while we keep
    // the original conditions documented for the future iteration.
    void isSignatureOrInitials;
    void resizeMode;
    void isOtherUsersField;
    void isDocumentCompleted;
    // Setup draggable hook
    const draggable = (0, core_1.useDraggable)({
        id: `preview-drag-${element._id}`,
        data: {
            type: element.type,
            elementId: element._id,
            dragType: "preview-translation",
        },
        disabled: !isDraggable,
    });
    const { setNodeRef: setDragNodeRef, setActivatorNodeRef, listeners, attributes, isDragging, transform } = draggable;
    // Handle drag end - update element position
    (0, core_1.useDndMonitor)({
        onDragEnd: (e) => {
            var _a, _b, _c, _d, _e, _f;
            const { active, delta } = e;
            const dragType = (_b = (_a = active === null || active === void 0 ? void 0 : active.data) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.dragType;
            const elementId = (_d = (_c = active === null || active === void 0 ? void 0 : active.data) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.elementId;
            // Only handle our own drag events
            if (dragType !== "preview-translation" || elementId !== element._id) {
                return;
            }
            // Get the actual page container dimensions to calculate proper delta conversion
            const pageElement = document.getElementById(`document_${element.page || 0}`);
            const pageWidth = (pageElement === null || pageElement === void 0 ? void 0 : pageElement.clientWidth) || (0, scaleFunction_1.scaleFunction)(docDimensions.width, docDimensions.width);
            const pageHeight = (pageElement === null || pageElement === void 0 ? void 0 : pageElement.clientHeight) || (0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width);
            // Convert screen pixel delta to original document coordinates
            // Delta is in screen pixels, we need to convert to document coordinate space
            const deltaXInDocCoords = (Number((delta === null || delta === void 0 ? void 0 : delta.x) || 0) / pageWidth) * docDimensions.width;
            const deltaYInDocCoords = (Number((delta === null || delta === void 0 ? void 0 : delta.y) || 0) / pageHeight) * docDimensions.height;
            let _x = Number(((_e = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _e === void 0 ? void 0 : _e.x) || 0) + deltaXInDocCoords;
            let _y = Number(((_f = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _f === void 0 ? void 0 : _f.y) || 0) + deltaYInDocCoords;
            // Clamp position so the field stays fully on the page. Width-aware
            // bounds prevent the field's right/bottom edge from going off-page.
            const elemW = element.width || 150;
            const elemH = element.height || 50;
            _x = Math.max(0, Math.min(_x, docDimensions.width - elemW));
            _y = Math.max(0, Math.min(_y, docDimensions.height - elemH));
            // Update element in Redux
            const updatedElement = Object.assign(Object.assign({}, element), { extra_attributes: Object.assign(Object.assign({}, element.extra_attributes), { x: _x, y: _y }) });
            dispatch((0, document_1.editSelectedDocumentElements)(updatedElement));
            // Save immediately via the status-aware thunk so the right endpoint is hit
            // (DRAFT → /draft/update-single-element, others → /update-single-document-element).
            // Going through batch_save_elements_thunk hardcodes /draft/batch-update-elements
            // and is rejected by the backend isDraft middleware in SIGNING/SENT/VIEWED.
            if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id) {
                dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                    data: {
                        document_id: selectedDocument._id,
                        payload: updatedElement,
                    },
                }));
            }
        },
    });
    // Transform for drag translation and mobile scaling
    // Container is 2x on mobile, scale back to 50% (net effect: larger space for content, smaller visual)
    // Page backgrounds should NOT be scaled - they fill 100% of the container already
    const baseTransform = (fieldTransformScale < 1 && !isPageBackground) ? `scale(${fieldTransformScale})` : '';
    const dragTransform = transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : '';
    const combinedTransform = [baseTransform, dragTransform].filter(Boolean).join(' ') || undefined;
    // Calculate responsive max constraints for ResizableBox (in unscaled units)
    const getResponsiveMaxConstraints = () => {
        if (typeof window === "undefined")
            return [500, 300];
        const viewportWidth = window.innerWidth;
        // On mobile devices, limit to viewport width with some padding (unscaled)
        if (viewportWidth < 640) {
            return [200, 120];
        }
        return [500, 300]; // Default desktop constraints (unscaled)
    };
    // Show label on hover (desktop) or focus (mobile)
    const shouldShowLabel = signerInfo && (isHovered || isFocused);
    return (react_1.default.createElement("div", { ref: (node) => {
            wrapperRef.current = node;
            if (isDraggable) {
                setDragNodeRef(node);
            }
        }, style: Object.assign(Object.assign({}, style), (combinedTransform ? { transform: combinedTransform, transformOrigin: "top left" } : {})), className: `cursor-pointer ${isFillableField ? "" : "relative"} ${isDragging ? "opacity-80 z-50" : ""}`, onMouseMove: signerInfo && !constants_1.IS_MOBILE ? handleMouseMove : undefined, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), onTouchStart: () => constants_1.IS_MOBILE && setIsFocused(true) },
        shouldShowLabel && (react_1.default.createElement("div", { className: getLabelClasses(), style: { backgroundColor: getUserColor(signerInfo.email) } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUser, className: "text-xs flex-shrink-0" }),
            react_1.default.createElement("span", { className: "truncate" }, signerInfo.name))),
        isResizable ? (react_1.default.createElement(react_resizable_1.ResizableBox, { width: scaledWidth, height: scaledHeight, onResizeStart: handleResizeStart, onResize: handleResize, onResizeStop: handleResizeStop, minConstraints: [(0, scaleFunction_1.scaleFunction)(50), (0, scaleFunction_1.scaleFunction)(30)], maxConstraints: getResponsiveMaxConstraints(), resizeHandles: ["se", "sw", "ne", "nw"], className: "resizable-signature", transformScale: 1 },
            react_1.default.createElement("div", { style: { width: "100%", height: "100%" } },
                react_1.default.createElement(Elem, { elementInstance: Object.assign(Object.assign({}, element), { isEditable: !isOtherUsersField && !isDocumentCompleted }) })))) : isSignatureOrInitials ? (
        // Signature/Initials without resize mode - use 100% of parent container (percentage-based)
        react_1.default.createElement("div", { style: { position: "relative", width: "100%", height: "100%" } },
            isDraggable && (react_1.default.createElement("div", Object.assign({ ref: setActivatorNodeRef }, listeners, attributes, { className: `absolute -bottom-1 -right-1 bg-primary text-white p-1.5 rounded-full shadow-md z-[1001] cursor-grab active:cursor-grabbing ${isDragging ? "cursor-grabbing scale-110" : "hover:scale-110"} transition-transform`, title: "Drag to move" }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowsAlt, className: "text-xs" }))),
            react_1.default.createElement(Elem, { elementInstance: Object.assign(Object.assign({}, element), { isEditable: !isOtherUsersField && !isDocumentCompleted }) }))) : (
        // Other field types - fill the wrapper's explicit width/height so the
        // sign and completed views render at the same dimensions as the editor
        // (matches document_element_wrapper.tsx).
        react_1.default.createElement("div", { style: { width: "100%", height: "100%" } },
            react_1.default.createElement(Elem, { elementInstance: Object.assign(Object.assign({}, element), { isEditable: !isOtherUsersField && !isDocumentCompleted }) })))));
};
exports.PreviewDocumentElementWrapper = PreviewDocumentElementWrapper;
